export const enumObj = {
    // xxxxx
    /**
     * 用户模块
     */
    userType: [{
            label: '运营人员',
            value: '1'
        },
        {
            label: '客服',
            value: '2'
        },
        {
            label: '用户管理员',
            value: '3'
        },
        {
            label: '超级管理员',
            value: '9'
        }
    ],
    // 店铺状态
    shopStatusOptions: [{
            label: '待审核',
            value: '0'
        },
        {
            label: '驳回',
            value: '1'
        },
        {
            label: '待门店上线',
            value: '2'
        },
        {
            label: '已上线',
            value: '3'
        }
    ],
    // 发票类型
    invoiceType: [{
            label: '电子发票',
            value: 0
        },
        {
            label: '纸质发票',
            value: 1
        }
    ],
    // 支付类型
    payType: [{
            label: '在线支付',
            value: 0
        },
        {
            label: '货到付款',
            value: 1
        }
    ],
    // 是 否
    whether: [{
            label: '是',
            value: 1
        },
        {
            label: '否',
            value: 0
        }
    ],
    /**
     * 店铺管理枚举
     */
    shopManagement: {
        // 门店状态 状态(列表展示使用,-1待审核,0审核驳回,1审核通过(或称为待门店上线),10已下线,11已上线)
        status: [{
                label: '待审核',
                value: -1
            },
            {
                label: '审核驳回',
                value: 0
            },
            {
                label: '审核通过',
                value: 1
            },
            {
                label: '已下线',
                value: 10
            },
            {
                label: '已上线',
                value: 11
            }
        ],
        // 门店分类
        storeEnum: [{
                label: '旗舰店',
                value: 1
            },
            {
                label: '专卖店',
                value: 2
            },
            {
                label: '专营店',
                value: 3
            }
        ],
        // 支付类型
        payType: [{
                label: '全部',
                value: '1,2'
            },
            {
                label: '货到付款',
                value: '1'
            },
            {
                label: '在线支付',
                value: '2'
            }
        ],
        // 发票类型
        invoiceType: [{
                label: '全部',
                value: '1,2'
            },
            {
                label: '电子发票',
                value: '1'
            },
            {
                label: '纸质发票',
                value: '2'
            }
        ],
        // 预约配送
        supportAppoint: [{
                label: '不支持',
                value: 0
            },
            {
                label: '支持',
                value: 1
            }
        ]
    },
    /**
     * 商品管理 - 枚举
     */
    storeCommodity: {
        // 上架状态
        status: [{
                label: '上架',
                value: 0
            },
            {
                label: '下架',
                value: 1
            },
            {
                label: '驳回下架',
                value: 7
            }
        ],
        seoStatus: [{
                label: '无SEO关键字',
                value: 0
            },
            {
                label: '待审核',
                value: 1
            },
            {
                label: '审核通过',
                value: 2
            },
            {
                label: '审核驳回',
                value: 3
            },
        ],
        takeEffect: [{
                label: '生效',
                value: 1
            },
            {
                label: '不生效',
                value: 0
            },
        ]
    },
    /**
     * 商品提报
     */
    product: {
        applyStatus: [{
                label: '待审核',
                value: '1'
            },
            {
                label: '审核中',
                value: '4'
            },
            {
                label: '审核驳回',
                value: '2'
            },
            {
                label: '审核成功',
                value: '3'
            }
        ]
    },
    /**
     * 运费设置
     */
    freight: {
        isTrue: [{
                label: '有效',
                value: 1
            },
            {
                label: '无效',
                value: 2
            }
        ],
        deliveryType: [{
                label: 'O2O',
                value: 1
            },
            {
                label: 'B2C',
                value: 2
            }
        ]
    },
    /**
     * 促销枚举
     */
    promotion: {
        // 活动状态 0：创建 1：有效 2：无效
        status: [{
                label: '创建',
                value: '0'
            },
            {
                label: '有效',
                value: '1'
            },
            {
                label: '无效',
                value: '2'
            }
        ],
        // 是否所有药店，1：是，2：否
        isAllPharmacy: [{
                label: '全部',
                value: '1'
            },
            {
                label: '指定',
                value: '2'
            }
        ],
        // 范围类型，1：全场；2：品牌；3：SKU
        rangeType: [{
                label: '全场',
                value: '1'
            },
            {
                label: '品牌',
                value: '2'
            },
            {
                label: 'SKU',
                value: '3'
            }
        ]
    },
    /**
     * 优惠券
     */
    coupon: {
        status: [{
                label: '全部',
                value: '0'
            },
            {
                label: '未开始',
                value: '1'
            },
            {
                label: '进行中',
                value: '2'
            },
            {
                label: '已结束',
                value: '3'
            }
        ],
        couponType: [{
                label: '全部',
                value: '0'
            },
            {
                label: '发放券',
                value: '2'
            },
            {
                label: '领用券',
                value: '1'
            },
            {
                label: '千人千面券',
                value: '3'
            }
        ],
        type: [{
                label: '全部',
                value: '0'
            },
            {
                label: '满减',
                value: '1'
            },
            {
                label: '立减',
                value: '2'
            }
        ]
    },
    /**
     * 客户运营枚举
     */
    customer: {
        ddCardStatus: [{
                label: '待确认',
                value: '1'
            },
            {
                label: '未开始',
                value: '2'
            },
            {
                label: '进行中',
                value: '3'
            },
            {
                label: '已结束',
                value: '4'
            },
            {
                label: '已取消',
                value: '5'
            }
        ],
        // 活动状态 状态 0 已删除 1 正常
        status: [{
                label: '删除',
                value: 0
            },
            {
                label: '正常',
                value: 1
            }
        ]
    },
    /**
     * 结算管理
     */
    final: {
        // 结算状态 // 状态1 未结算 2 结算中 3已结算 4已审核 5已付款 6已取消 7待二次审核
        status: [{
                label: '未结算',
                value: 1
            },
            {
                label: '结算中',
                value: 2
            },
            {
                label: '已结算',
                value: 3
            },
            {
                label: '已审核',
                value: 4
            },
            {
                label: '已付款',
                value: 5
            },
            {
                label: '已取消',
                value: 6
            },
            {
                label: '待二次审核',
                value: 7
            }
        ],
        // 开票状态 0 待开票   1 已开票
        invoiceStatus: [{
                label: '待开票',
                value: 0
            },
            {
                label: '已开票',
                value: 1
            }
        ],
        // 商品明细
        orderType: [{
                label: '正向订单',
                value: 1
            },
            {
                label: '退款订单',
                value: 2
            },
            {
                label: '客诉赔款',
                value: 1001
            },
            {
                label: '部分退款',
                value: 1002
            },
            {
                label: '三方差异',
                value: 1003
            },
            {
                label: '调整项',
                value: 1004
            }
        ],
        payType: [{
                label: '全部',
                value: ''
            },
            {
                label: '微信',
                value: 3
            },
            {
                label: '支付宝',
                value: 4
            }
        ]

    },
    /**
     * 公司鉴权管理
     */
    companyAuth: {
        // 账户类型
        acctType: [{
                label: '对公账户',
                value: 10
            },
            {
                label: '个体工商户',
                value: 20
            }
        ],
        bankType: [{
                label: '平安银行',
                value: '1'
            },
            {
                label: '非平安银行',
                value: '2'
            }
        ],
        bindStatus: [{
                label: '未绑卡（已开通账号）',
                value: 10
            },
            {
                label: '已绑定,未校验',
                value: 11
            },
            {
                label: '已校验',
                value: 12
            }
        ],
        IDType: [{
                label: '大陆身份证',
                value: '1'
            },
            {
                label: '港澳台居民通行证（即回乡证）',
                value: '3'
            },
            {
                label: '台湾居民来往大陆通行证（即台胞证）',
                value: '5'
            },
            {
                label: '外国护照',
                value: '19'
            }
        ]
    },
    /**
     * 批量提报
     */
    batch: {
        status: [{
                label: '处理中',
                value: 1
            },
            {
                label: '成功',
                value: 2
            },
            {
                label: '失败',
                value: 3
            }
        ]
    }
}